export const endpoints = {

    // USER
    userPermissions: '/user-permissions/building/:buildingId', // get user permissions and building id
    // EOP SUMMARY
    eopSummary: '/summary/building/:buildingId', // get EOP summary by building id
    alEopSummary: '/AL_EOP/summary/building/:buildingId', // get AL EOP summary by building id
    msEopSummary: '/MS_EOP/summary/building/:buildingId', // get MS EOP summary by building id
    gaEopSummary: '/GA_EOP/summary/building/:buildingId', // get GA EOP summary by building id
    
    // EOP ASSISTANT
    eopAssistant: '/eop_assistant/section/:section_id?sub_section_id=:sub_section_id',

    // CONTACT 
    contacts: '/contacts/:buildingId', // get all contacts of a building

    // DEPARTMENT 
    departments: '/collaborative_team_department/eopTemplateId/:eopTemplateId', // get all departments
    getBuildingDepartmentContacts: '/collaborative_contact_relationship/building/:buildingId/template/:eopTemplateId', // get all contacts of all departments in a building
    getDepartmentContacts: '/collaborative_contact_relationship/building/:buildingId/department/:departmentId', // get all contacts of all departments
    saveDepartmentContacts: '/collaborative_contact_relationship/building/:buildingId', // save contacts of the department
    removeDepartmentContacts: '/collaborative_contact_relationship/building/:buildingId/department/:departmentId', // remove all contacts of the department

    // AL EOP CORE PLANNING TEAM
    createBuildingCorePlanningTeam: '/core_planning_team/building/:buildingId/template/:eopTemplateId/team/:corePlanningTeamTypeId',
    deleteBuildingCorePlanningTeam: '/core_planning_team/delete/building/:buildingId/template/:eopTemplateId/team/:corePlanningTeamTypeId',
    approveBuildingCorePlanningTeam: '/core_planning_team/approve/building/:buildingId/template/:eopTemplateId/team/:corePlanningTeamTypeId',

    // ICS ROLES
    positions: '/ics/eopTemplateId/:eopTemplateId', // get all positions
    positionContact: '/ics_contactrelationship/building/:buildingId/eopTemplateId/:eopTemplateId', // get all contacts of all positions
    savePositionContacts: '/ics_contactrelationship/building/:buildingId', // save contacts of the position
    deleteAllPositionContacts: '/ics_contactrelationship/building/:buildingId', // delete all contacts of all positions
    approveBuildingICS: '/ics/approve/building/:buildingId/eopTemplateId/:eopTemplateId', // approve ICS for building

    // CALENDAR 
    schedules: '/calendar_log/building/:buildingId', // get all events
    createNewSchedule: '/calendar_log/building/:buildingId', // create new event
    editSchedule: '/calendar_log/:scheduleId', // edit event
    deleteSchedule: '/calendar_log/:scheduleId', // delete event

    // FILES
    uploadFile: '/uploadFile/section/:section_id/item/:item_id', // upload one or multiple files
    downloadFile: '/downloadFile/building/:building_id/section/:section_id/file/:file_id', // download one file
    deleteFile: '/deleteFile/building/:building_id/section/:section_id/file/:file_id', // delete one file

    // THREAT AND HAZARDS 
    threats: '/threat_hazards/building/:buildingId/logs', // get all threats
    createNewThreat: '/threat_hazards/building/:buildingId', // create new threat
    editThreat: '/threat_hazards/:threatId', // edit one threat
    deleteThreat: '/threat_hazards/:threatId', // delete one threat
    threatGoals: '/threat_hazards/building/:buildingId/goals/objectives', // get threat's goals and objectives
    createThreatGoals: '/threat_hazards/:threatId/create/goals', // create threat's goals
    editThreatGoals: '/threat_hazards/:threatId/update/goals/objectives', // update threat's goals
    deleteThreatGoals: '/threat_hazards/:threatId/delete/goals/objectives', // delete threat's goals

    // FUNCTION
    functions: '/functions/building/:buildingId', // get all functions
    createNewFunction: '/functions/building/:buildingId', // create new function
    editFunction: '/functions/update/:functionId', // edit one function
    deleteFunction: '/functions/delete/:functionId', // delete one function

    // FUNCTIONS ASSIGNED TO A THREAT
    getAllFunctionalAssignments: '/functional_assignment/building/:buildingId', // get all functions of a threat
    createFunctionalAssignment: '/functional_assignment/building/:buildingId/threat/:threatId', // save new functional assignment for a threat

    // FUNCTION'S COURSE OF ACTION 
    getCourseOfAction: '/course_of_actions/building/:buildingId/:functionOrThreat', // get course of action of a function
    updateCourseOfAction: '/course_of_actions/building/:buildingId/:functionOrThreat/:funcionThreatId', // create/update course of action of a function

    // THREAT'S COURSE OF ACTION
    getThreatsCourseOfAction: '/course_of_actions/building/:buildingId/threat/:threatId', // get course of action of a threat
    updateThreatesCourseOfAction: '/course_of_actions/threat', // create/update course of action of a threat

    // BASIC PLAN
    eopSectionsByBuildingId: '/eop_sections/building/:buildingId', // get EOP sections of a building id
    verifyIfSectionExistsOnBuilding: '/eop_sections/building/:buildingId/section/:sectionType', // verify if EOP section exists on building id
    eopSectionByStep: '/eop_sections/step/:step_number', // get EOP section by id
    createBasicPlanForBuilding: '/create_basic_plan/building/:buildingId', // create new EOP sections for building
    getEopDocument: '/eop_document/building/:buildingId/section/:sectionType', // get EOP document by building id, section type and sub section type
    updateEopDocument: '/eop_document/building/:buildingId/section/:sectionType', // update EOP document by building id, section type and sub section type
    approveEopDocument: '/approve_eop_document/building/:buildingId/section/:sectionType', // approve EOP document by building id, section type and sub section type

    // CUSTOM EOP SECTIONS
    customEopSectionsByBuildingId: '/custom_eop_sections/building/:buildingId', // get custom EOP sections by building id
    getCustomPageByPageId: '/custom_page/page/:pageId', // get custom EOP section by page id
    createCustomEopSection: '/create_custom_eop_section/building/:buildingId', // create new custom EOP section
    updateCustomEopSection: '/update_custom_eop_section/page/:pageId', // create new custom EOP section
    deleteCustomEopSection: '/delete_custom_eop_section/page/:pageId', // delete custom EOP section by page id

    // RECORD OF CHANGES
    getRecordOfChanges: '/record_of_changes/building/:buildingId', // get EOP Record of Changes

    // RECORD OF DISTRIBUTION
    getRecordOfDistribution: '/record_of_distribution/building/:buildingId', // get EOP Record of Distribution
    downloadEopDocument: '/download_eop_document/building/:buildingId', // download EOP document by building id, section type and sub section type
    sendEOP: '/sendEOP/building/:buildingId', // send EOP

    // AL EOP MATERIALS & EQUIPMENT
    getBuildingMaterialsAndEquipment: '/AL_EOP/materials_equipment/building/:buildingId', // get all materials & equipment of a building
    createMaterialAndEquipment: '/AL_EOP/materials_equipment/building/:buildingId', // create new material & equipment for a building
    editMaterialAndEquipment: '/AL_EOP/materials_equipment/update/building/:buildingId/:materialId', // edit one material & equipment
    approveBuildingMaterialsAndEquipment: '/AL_EOP/materials_equipment/approve/building/:buildingId', // approve materials & equipment for building
    deleteMaterialAndEquipment: '/AL_EOP/materials_equipment/delete/building/:buildingId/:materialId', // delete one material & equipment

    // AL EOP BASIC RESOURCES
    getBuildingBasicResources: '/AL_EOP/basic_resources/building/:buildingId', // get all basic resources of a building
    createBasicResource: '/AL_EOP/basic_resources/building/:buildingId', // create new basic resource for a building
    editBasicResource: '/AL_EOP/basic_resources/update/building/:buildingId/:materialId', // edit one basic resource
    approveBuildingBasicResources: '/AL_EOP/basic_resources/approve/building/:buildingId', // approve basic resources for building
    deleteBasicResource: '/AL_EOP/basic_resources/delete/building/:buildingId/:materialId', // delete one basic resource

    // HAZARD ANNEXES
    getBuildingALAssessments: '/AL_EOP/assessments_log/building/:buildingId/assessment/:assessmentTypeId', // get all assess 
    sendALAssessmentRequest: '/AL_EOP/send_assessments/building/:buildingId/assessment_type/:assessmentTypeId/sub_type/:assessmentSubTypeId', // send assessment request
    sendClassroomALAssessmentRequest: '/AL_EOP/send_classroom_assessments/building/:buildingId/room/:roomNumber', // send classroom assessment request
    updateALAssessment: '/AL_EOP/update_assessment/building/:buildingId/assessment_type/:assessmentTypeId/sub_type/:assessmentSubTypeId',
    createALClassroomAssessment: '/AL_EOP/create_classroom_assessment/building/:buildingId', // create classroom assessment
    updateALClassroomAssessment: '/AL_EOP/update_classroom_assessment/building/:buildingId/assessment/:assessmentId', // update classroom assessment
    confirmALAssessment: '/AL_EOP/confirm_assessments/building/:buildingId/assessment_type/:assessmentTypeId', // confirm assessment
    deleteALAssessment: '/AL_EOP/assessments_log/delete/:assessId', // delete one assess
    downloadSurvey: '/AL_EOP/assessments_log/download/:guid', // download survey by guid
    
    // AL EOP DISTRICT COORDINATOR TRAINING LOG
    getBuildingCoordinatorTrainings: '/AL_EOP/district_coordinator_training_log/building/:buildingId', // get all events
    createNewCoordinatorTraining: '/AL_EOP/district_coordinator_training_log/building/:buildingId', // create new event
    updateCoordinatorTraining: '/AL_EOP/district_coordinator_training_log/update/:itemId', // edit event
    deleteCoordinatorTraining: '/AL_EOP/district_coordinator_training_log/delete/:itemId', // delete event

    // AL EOP CRISIS MANAGEMENT
    getCrisisManagement: '/AL_EOP/crisis_management/building/:buildingId', // get crisis management by building id
    updateCrisisManagement: '/AL_EOP/crisis_management/building/:buildingId', // update crisis management by building id
    approveCrisisManagement: '/AL_EOP/crisis_management/approve/building/:buildingId', // approve crisis management by building id

    // EOP DRILL TRAINING REPORTS
    getBuildingReports: '/drill_report_log/building/:buildingId', // get all events
    createNewReport: '/drill_report_log/building/:buildingId', // create new event
    updateReport: '/drill_report_log/update/:itemId', // edit event
    deleteReport: '/drill_report_log/delete/:itemId', // delete event
    
    // AFTERSCHOOL ACTIVITY
    getBuildingAfterschoolActivities: '/afterschool_activities/building/:buildingId', // get all afterschool activities
    createNewAfterschoolActivity: '/afterschool_activities/building/:buildingId', // create new afterschool activity
    updateAfterschoolActivity: '/afterschool_activities/update/building/:buildingId/:activityId', // edit afterschool activity
    deleteAfterschoolActivity: '/afterschool_activities/delete/building/:buildingId/:activityId', // delete afterschool activity
    approveBuildingAfterschoolActivities: '/afterschool_activities/approve/building/:buildingId', // approve afterschool activity for building

    downloadALEop: '/AL_EOP/download_eop/building/:buildingId', // download EOP document by building id, section type and sub section type
    downloadMSEop: '/MS_EOP/download_eop/building/:buildingId', // download MS EOP document by building id, section type and sub section type
    downloadGAEop: '/GA_EOP/download_eop/building/:buildingId', // download GA EOP document by building id

    // GA EOP SCHOOL DEMOGRAPHICS
    getSchoolDemographics: '/GA_EOP/school_demographics/building/:buildingId', // get GA school demographics by building id
    updateSchoolDemographics: '/GA_EOP/school_demographics/building/:buildingId', // upsert GA school demographics by building id

    // GA EOP NUMBER OF STUDENT, STAFF, ROOMS
    getNumberStudentStaffRooms: '/GA_EOP/number_student_staff_rooms/building/:buildingId', // get GA number of student/staff/rooms by building id
    updateNumberStudentStaffRooms: '/GA_EOP/number_student_staff_rooms/building/:buildingId', // upsert GA number of student/staff/rooms by building id

    // GA EOP SHELTER INFORMATION
    getShelterInformation: '/GA_EOP/shelter_information/building/:buildingId', // get GA shelter information by building id
    updateShelterInformation: '/GA_EOP/shelter_information/building/:buildingId', // upsert GA shelter information by building id

    // GA EOP HAZARDOUS MATERIALS IN SCHOOL FACILITY
    getHazardousMaterials: '/GA_EOP/hazardous_materials/building/:buildingId', // get all GA hazardous materials by building id
    createHazardousMaterial: '/GA_EOP/hazardous_materials/building/:buildingId', // create a GA hazardous material
    updateHazardousMaterial: '/GA_EOP/hazardous_materials/update/building/:buildingId/:itemId', // update a GA hazardous material by id
    deleteHazardousMaterial: '/GA_EOP/hazardous_materials/delete/building/:buildingId/:itemId', // delete a GA hazardous material by id

    // GA EOP TRANSPORTATION NEEDS
    getTransportationNeeds: '/GA_EOP/transportation_needs/building/:buildingId', // get GA transportation needs by building id
    updateTransportationNeeds: '/GA_EOP/transportation_needs/building/:buildingId', // upsert GA transportation needs by building id

    // GA EOP EVACUATION ROUTES (Fire / Bomb)
    getEvacuationRoutes: '/GA_EOP/evacuation_routes/building/:buildingId/type/:routeType', // list fire/bomb routes
    createEvacuationRoute: '/GA_EOP/evacuation_routes/building/:buildingId/type/:routeType', // create a fire/bomb route
    updateEvacuationRoute: '/GA_EOP/evacuation_routes/update/building/:buildingId/:itemId', // update a route by id
    deleteEvacuationRoute: '/GA_EOP/evacuation_routes/delete/building/:buildingId/:itemId', // delete a route by id

    // GA EOP SEVERE WEATHER SHELTERING LOCATIONS
    getSevereWeatherLocations: '/GA_EOP/severe_weather_locations/building/:buildingId', // list severe weather locations
    createSevereWeatherLocation: '/GA_EOP/severe_weather_locations/building/:buildingId', // create a severe weather location
    updateSevereWeatherLocation: '/GA_EOP/severe_weather_locations/update/building/:buildingId/:itemId', // update by id
    deleteSevereWeatherLocation: '/GA_EOP/severe_weather_locations/delete/building/:buildingId/:itemId', // delete by id

    // GA EOP CRISIS EVENT STAGING AREAS
    getCrisisStagingAreas: '/GA_EOP/crisis_staging_areas/building/:buildingId', // get crisis staging areas
    updateCrisisStagingAreas: '/GA_EOP/crisis_staging_areas/building/:buildingId', // upsert crisis staging areas

    // GA EOP RELOCATION SITES
    getRelocationSites: '/GA_EOP/relocation_sites/building/:buildingId', // get relocation sites
    updateRelocationSites: '/GA_EOP/relocation_sites/building/:buildingId', // upsert relocation sites

    // GA EOP EMERGENCY EVACUATION KITS
    getEmergencyEvacuationKits: '/GA_EOP/emergency_evacuation_kits/building/:buildingId', // list emergency evacuation kits
    createEmergencyEvacuationKit: '/GA_EOP/emergency_evacuation_kits/building/:buildingId', // create a kit
    updateEmergencyEvacuationKit: '/GA_EOP/emergency_evacuation_kits/update/building/:buildingId/:itemId', // update a kit by id
    deleteEmergencyEvacuationKit: '/GA_EOP/emergency_evacuation_kits/delete/building/:buildingId/:itemId', // delete a kit by id

    // GA EOP SPECIAL NEEDS CONSIDERATION (students / staff)
    getSpecialNeedsStudents: '/GA_EOP/special_needs_students/building/:buildingId',
    createSpecialNeedsStudent: '/GA_EOP/special_needs_students/building/:buildingId',
    updateSpecialNeedsStudent: '/GA_EOP/special_needs_students/update/building/:buildingId/:itemId',
    deleteSpecialNeedsStudent: '/GA_EOP/special_needs_students/delete/building/:buildingId/:itemId',
    getSpecialNeedsStaff: '/GA_EOP/special_needs_staff/building/:buildingId',
    createSpecialNeedsStaff: '/GA_EOP/special_needs_staff/building/:buildingId',
    updateSpecialNeedsStaff: '/GA_EOP/special_needs_staff/update/building/:buildingId/:itemId',
    deleteSpecialNeedsStaff: '/GA_EOP/special_needs_staff/delete/building/:buildingId/:itemId',

    // GA EOP EMERGENCY UTILITIES CHECKLIST
    getEmergencyUtilitiesChecklist: '/GA_EOP/emergency_utilities_checklist/building/:buildingId',
    updateEmergencyUtilitiesChecklist: '/GA_EOP/emergency_utilities_checklist/building/:buildingId',

    // GA EOP CPR/FIRST AID/AED (instructors / certified staff)
    getCprInstructors: '/GA_EOP/cpr_instructors/building/:buildingId',
    createCprInstructor: '/GA_EOP/cpr_instructors/building/:buildingId',
    updateCprInstructor: '/GA_EOP/cpr_instructors/update/building/:buildingId/:itemId',
    deleteCprInstructor: '/GA_EOP/cpr_instructors/delete/building/:buildingId/:itemId',
    getCprCertifiedStaff: '/GA_EOP/cpr_certified_staff/building/:buildingId',
    createCprCertifiedStaff: '/GA_EOP/cpr_certified_staff/building/:buildingId',
    updateCprCertifiedStaff: '/GA_EOP/cpr_certified_staff/update/building/:buildingId/:itemId',
    deleteCprCertifiedStaff: '/GA_EOP/cpr_certified_staff/delete/building/:buildingId/:itemId',
};

  